module.exports = __webpack_public_path__ + "static/media/SA.fbd538a6.png";